import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./assets/scss/style.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Product from "./pages/Product";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import CategoryPage from "./pages/CategoryPage";
import Category from "./pages/Category";
import ScrollToTop from "./components/UIElements/ScrollTop";

import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Payment from "./pages/Payment";
import Contact from "./pages/Contact";
import Pay from "./pages/Pay";
import Topbar from "./components/UIElements/Topbar";
import UserBar from "./components/UIElements/UserBar";
import NavMenu from "./components/UIElements/Navbar";
import MobileNavbar from "./components/UIElements/MobileNavbar";
import Footer from "./components/Footer";

import Register from "./pages/Register";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import NewPassword from "./pages/NewPassword";
import MyAccount from "./pages/Account/MyAccount";
import MyOrders from "./pages/Account/MyOrders";
import MyProfile from "./pages/Account/MyProfile";
import MyAddress from "./pages/Account/MyAddress";
import Helpdesk from "./pages/Account/Helpdesk";

import Success from "./pages/Success";

import ProtectRoutes from "./utils/PrivateRoute";
import { useSelector } from "react-redux";

const App = () => {
  //
  // const user = useSelector((state) => state.user.currentUser);

  return (
    <BrowserRouter>
      <ToastContainer />
      <ScrollToTop />
      <Topbar />
      <UserBar />
      <NavMenu />
      <MobileNavbar />
      <Routes>
        <Route element={<Home />} path="/" exact="true" />

        <Route element={<Shop />} path="/products" exact="true" />

        {/* <Route element={<Category />} path="/products/:category" exact="true" /> */}

        <Route
          element={<CategoryPage />}
          path="/products/:category"
          exact="true"
        />

        <Route element={<Product />} path="/product/:id" exact="true" />

        <Route element={<Cart />} path="/cart" exact="true" />

        <Route element={<Wishlist />} path="/wishlist" exact="true" />

        <Route element={<Pay />} path="/pay" exact="true" />

        <Route element={<Success />} path="/success" exact="true" />

        <Route element={<Contact />} path="/contact" exact="true" />

        <Route element={<Login />} path="/login" exact="true" />

        <Route element={<Register />} path="/register" exact="true" />

        <Route
          element={<ResetPassword />}
          path="/reset-password"
          exact="true"
        />

        <Route
          element={<NewPassword />}
          path="/new-password/:token"
          exact="true"
        />

        <Route element={<ProtectRoutes />}>
          <Route element={<Payment />} path="/payment" exact="true" />

          <Route element={<MyAccount />} path="/my-account" exact="true" />

          <Route element={<MyOrders />} path="/my-orders" exact="true" />

          <Route element={<MyOrders />} path="/my-orders" exact="true" />

          <Route element={<MyProfile />} path="/my-profile" exact="true" />

          <Route element={<Helpdesk />} path="/helpdesk" exact="true" />

          <Route element={<MyAddress />} path="/my-address" exact="true" />
        </Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
